'use client';

import { SearchResultsSkeleton } from './SearchResults/Skeleton';
import { SearchSidebarSkeleton } from './SearchSidebar/Skeleton';
export function SearchSkeleton() {
  return <>
      <SearchSidebarSkeleton />
      <SearchResultsSkeleton />
    </>;
}